export const SocialData = [
  {
    platform: 'Linkedin',
    icon: require('../../assets/icons/linkedin.png'),
    link: 'https://www.linkedin.com/in/sean-jordaan-a24b921a1/',
  },
  {
    platform: 'Github',
    icon: require('../../assets/icons/github.png'),
    link: 'https://github.com/SeanJordaan',
  },

  {
    platform: 'Facebook',
    icon: require('../../assets/icons/facebook.png'),
    link: 'https://www.facebook.com/sean.jordaan.3',
  },
  {
    platform: 'GMail',
    icon: require('../../assets/icons/gmail.png'),
    link: 'mailto:jordaansean7@gmail.com',
  },
];
